module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('Form_Element_FileUploader', {
		init: function() {
			var container;

			this.callParent('init', arguments);

			if (this.form.getOption('formContainer')) {
				container = this.form.getOption('formContainer') + ' ' + this.requireOption('container');
			} else {
				container = this.requireOption('container');
			}
			
			this.registerOptions('.Controller', {
				'embed.container': container,
				autoRender: true
			});

			this.initWidgets();
		},

		syncState: function() {
			var upload = this.wom('.Api').pop();

			if (!upload || fox.oop.instanceOf(upload, 'ClientFileUploaderBox')) {
				return;
			}

			this.inProgress = upload.inProgress;

			if (upload.lastResponse) {
				upload.dispatchResponseEvent(upload.lastResponse);
			}
		},

		activate: function() {
			this.syncState();
			this.switchState();
			this.callParent('activate', arguments);
		},

		switchState: function() {
			var w;

			this.callParent('switchState', arguments);

			w = this.getEmbeddedWidget(this.state);
			
			if (this.state == 'exists') {
				this.rwom1('#exists').templateOptions = this.fileInfo;
			}

			if (this.state == 'input') {
				this.rwom1('#input').templateOptions = this.getOption('templateOptions');
			}

			if (w) {
				if (w.isActive()) {
					w.render();
				} else {
					this.switchEmbeddedWidget(this.state);
				}
			}

			return this.state;
		},

		initWidgets: function() {
			var 
			props = fox.merge({
				widget: 'Widget',
				active: false,
				handleDom: {
					changed: {
						target: 'input',
						event: 'change',
						callback: '@parent:changeHandler'
					}
				}
			}, this.getOption('input'));
			this.embedWidget('input', props.widget, props);

			props = fox.merge({
				widget: 'Widget',
				active: false,
				'handleWom.progress': {
					widget: '@parent .Api',
					event: 'progress',
					callback: 'handlerWom:progressBar'
				},
				'handlerWom.progressBar': function(params, uploader) {
					var fileMeta = this.getParent().filesMeta[uploader.getId()];

					if (fileMeta) params.fileName = fileMeta.name;
					this.templateOptions = params;
					this.render();
				}
			}, this.getOption('progress'));
			this.embedWidget('progress', props.widget, props);

			props = fox.merge({
				widget: 'Widget',
				active: false,
				'handleDom.del': {
					target: '.close',
					event: 'click',
					callback: '@parent:del'
				}
			}, this.getOption('exists'));
			this.embedWidget('exists', props.widget, props);

			props = fox.merge({
				widget: 'Widget',
				active: false,
				'handleWom.uploadFailed': {
					event: ['error', 'failure'],
					widget: '@parent .Api',
					callback: function (params, uploader) {
						var fileMeta = this.getParent().filesMeta[uploader.getId()];

						if (fileMeta) this.setTemplateOptions({fileName: fileMeta.name}).render();
					}
				}
			}, this.getOption('failed'));
			
			this.embedWidget('failed', props.widget, props);
		},

		del: function() {
			if (this.isDisabled) {
				return;
			}

			this.fileInfo = {};
			this.form.autoSubmit = true;
			this.setOption('info.skipInfo', true);
			this.setValue(0);
			this.setOption('info.skipInfo', false);
			this.form.autoSubmit = this.form.getOption('autoSubmit');
			this.switchState();
		}
		
	}, 'Form_Element_FileUploaderSimple');
})(fox);


 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/form/elements/fileuploader.js
// module id = 192
// module chunks = 0